import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {ValidateDate} from '../../../../validators/date.validator';
import {ReportService} from '../../../../services/report.service';
import {Router} from '@angular/router';
import {ClientService} from '../../../../services/client.service';
import {minDateValidator} from '../../../../validators/min-date.validator';

@Component({
  selector: 'app-ervo-dialog',
  styleUrls: ['./ervo-dialog.component.scss'],
  templateUrl: './ervo-dialog.component.html',
})
export class ErvoDialogComponent implements OnInit {

  submitted = false;
  form;
  client;

  constructor(public dialogRef: MatDialogRef<ErvoDialogComponent>,
              private builder: FormBuilder,
              private router: Router,
              private reportService: ReportService,
              private clientService: ClientService,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.clientService.getOne(this.data.clientId).subscribe(client => {
      this.client = client;
      this.form = this.getCleanForm();
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onCreateReport(type) {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    const date = this.f.valueOf('date').date.value;
    this.clientService.finish(type, date, this.client.id).subscribe(() => {
      this.router.navigate(this.reportService.getReportUrl(this.client.id, type, null));
      this.cancel();
    });
  }

  private getCleanForm() {
    return this.builder.group({
      'date': ['', [Validators.required, ValidateDate, minDateValidator(this.client.startDate)]],
    });
  }
}
